import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import { useAuthStore } from '@/stores/auth'
import lookups from '@/assets/json/clientLookups.json'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    fileNumber = '',
    sponsoredUN = '',
    administrativeRegionId = '',
    withException = ''
  } = router.currentRoute.value.query

  formStore.extraMap = {
    ...formStore.extraMap,
    visaDuarationMsg: '',
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }

  if (sponsoredUN) {
    let res = await apiHelperService.post(
      `/api/icaRequest/draft/prepareResiEidaNewPassportRequest?serviceTransId=${serviceTransactionId}`,
      {
        unifiedNumber: sponsoredUN,
        sponsoredFileNumber: fileNumber,
        serviceTransactionId: serviceTransactionId
      }
    )
    if (res) {
      const { eidaRequest = {} } = res.data || {}
      setDefaultVal(eidaRequest)
    }
  }
}

const setDefaultVal = (res) => {
  const formStore = useFormStore()
  const { manageFields = {} } = res

  formStore.draft.request = {
    ...formStore.draft.request,
    ...res,
    userHadTheOldCardOrCopy: '0',
    applicationRequestTypeId: 3,
    manageFields: {}
  }
  formStore.draft.request.manageFields = manageFields
}

const initInfo = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const { applicationId } = authStore.user
  const {
    application: { TypingCenter, establishment }
  } = lookups
  const res = await apiHelperService.get(
    [establishment, TypingCenter].includes(applicationId)
      ? '/api/establishment/info'
      : '/api/individual/info'
  )
  if (res) {
    const { identityNumber = '', genderId = '' } = res
    formStore.draft.request.individualInfo = res
    formStore.draft.request = {
      ...formStore.draft.request,
      sponsorIdentityNumber: identityNumber,
      sponsorGenderId: genderId
    }
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use92Preload error: ', error)
  }
}
